import type { UIMessage } from "ai";
import { settleWriteToolPartInMessages } from "./settleWriteToolPartInMessages";

export function finalizeWriteApprovalStreamMessages({
  messages,
  toolCallId,
  isWriteToolName,
  path,
  declineReason,
}: {
  messages: UIMessage[];
  toolCallId: string;
  isWriteToolName: (toolName: string) => boolean;
  path: "approve" | "decline";
  declineReason?: string;
}): UIMessage[] {
  if (!toolCallId) return messages;
  return settleWriteToolPartInMessages({
    messages,
    toolCallId,
    isWriteToolName,
    outcome: path === "decline" ? "declined" : "approved",
    declineReason,
  });
}
